
const textAndMediaDescription = 'All content associated with a post will be included.';
const textOnlyDescription = 'No images or video will be included.';
const mediaOnlyDescription = 'No post text will be included.';

const textAndMediaTitle = 'Text and Media';
const textOnlyTitle = 'Text Only';
const mediaOnlyTitle = 'Media Only';

const TGB_ASSETS_URL = process.env.TGB_ASSETS_CDN_URL;
const facebookLogoUrl = `${TGB_ASSETS_URL}/logos/facebook`;
const twitterLogoUrl = `${TGB_ASSETS_URL}/logos/twitter`;
const instagramLogoUrl = `${TGB_ASSETS_URL}/logos/instagram`;
const youtubeLogoUrl = `${TGB_ASSETS_URL}/logos/youtube`;
const tiktokLogoUrl = `${TGB_ASSETS_URL}/logos/tiktok`;
const redditLogoUrl = `${TGB_ASSETS_URL}/logos/reddit`;
const heymarketLogoUrl = `${TGB_ASSETS_URL}/logos/heymarket`;
const twitchLogoUrl = `${TGB_ASSETS_URL}/logos/twitch`;
const shareItLogoUrl = `${TGB_ASSETS_URL}/logos/share-it`;
const threadsLogoUrl = `${TGB_ASSETS_URL}/logos/threads`;

export const allContentTypes = {
  textAndMedia: {
    title: textAndMediaTitle,
    description: textAndMediaDescription,
    img: '/img/social-types/isolated-text-and-media.svg',
  },
  textOnly: {
    title: textOnlyTitle,
    description: textOnlyDescription,
    img: '/img/social-types/isolated-text-only.svg',
  },
  mediaOnly: {
    title: mediaOnlyTitle,
    description: mediaOnlyDescription,
    img: '/img/social-types/isolated-media-only.svg',
  },
};

// normalization of social network branding data, at some point this is better kept in the DB
export const socialNetworkBranding = {
  facebook: {
    logos: {
      svg: {
        icons: {
          primary: `${facebookLogoUrl}/logo-facebook-primary.svg`,
          white: `${facebookLogoUrl}/logo-facebook-white.svg`,
          black: `${facebookLogoUrl}/logo-facebook-black.svg`,
        },
      },
    },
    colors: {
      primary: '#0866ff',
      secondary: '#ffffff',
    },
  },
  instagram: {
    logos: {
      svg: {
        icons: {
          primary: `${instagramLogoUrl}/logo-instagram-primary.svg`,
          white: `${instagramLogoUrl}/logo-instagram-white.svg`,
          black: `${instagramLogoUrl}/logo-instagram-black.svg`,
        },
      },
    },
    colors: {
      primary: '#FF0069',
      secondary: '#ffd600',
    },
  },
  youtube: {
    logos: {
      svg: {
        icons: {
          primary: `${youtubeLogoUrl}/logo-youtube-primary.svg`,
          white: `${youtubeLogoUrl}/logo-youtube-white.svg`,
          black: `${youtubeLogoUrl}/logo-youtube-black.svg`,
        },
      },
    },
    colors: {
      primary: '#FF0000',
      secondary: '#ffffff',
    },
  },
  twitter: {
    logos: {
      svg: {
        icons: {
          primary: `${twitterLogoUrl}/logo-x-primary.svg`,
          white: `${twitterLogoUrl}/logo-x-white.svg`,
          black: `${twitterLogoUrl}/logo-x-primary.svg`,
        },
      },
    },
    colors: {
      primary: '#000000',
      secondary: '#FFFFFF',
    },
  },
  tiktok: {
    logos: {
      svg: {
        icons: {
          primary: `${tiktokLogoUrl}/logo-tiktok-primary.svg`,
          white: `${tiktokLogoUrl}/logo-tiktok-white.svg`,
          black: `${tiktokLogoUrl}/logo-tiktok-black.svg`,
        },
      },
    },
    colors: {
      primary: '#fe2c55',
      secondary: '#25f4ee',
    },
  },
  reddit: {
    logos: {
      svg: {
        icons: {
          primary: `${redditLogoUrl}/logo-reddit-primary.svg`,
          white: `${redditLogoUrl}/logo-reddit-white.svg`,
          black: `${redditLogoUrl}/logo-reddit-black.svg`,
        },
      },
    },
    colors: {
      primary: '#FF4500',
      secondary: '#FFFFFF',
    },
  },
  heymarket: {
    logos: {
      svg: {
        icons: {
          primary: `${heymarketLogoUrl}/logo-heymarket-primary.svg`,
          white: `${heymarketLogoUrl}/logo-heymarket-white.svg`,
          black: `${heymarketLogoUrl}/logo-heymarket-black.svg`,
        },
      },
    },
    colors: {
      primary: '#000000',
      secondary: '#ffc926',
    },
  },
  twitch: {
    logos: {
      svg: {
        icons: {
          primary: `${twitchLogoUrl}/logo-twitch-primary.svg`,
          white: `${twitchLogoUrl}/logo-twitch-white.svg`,
          black: `${twitchLogoUrl}/logo-heymarket-black.svg`,
        },
      },
    },
    colors: {
      primary: '#9146FF',
      secondary: '#F0F0FF',
    },
  },
  threads: {
    logos: {
      svg: {
        icons: {
          primary: `${threadsLogoUrl}/logo-threads-primary.svg`,
          white: `${threadsLogoUrl}/logo-threads-white.svg`,
          black: `${threadsLogoUrl}/logo-threads-primary.svg`,
        },
      },
    },
    colors: {
      primary: '#000000',
      secondary: '#FFFFFF',
    },
  },
  /* 'share-it': {
    logos: {
      svg: {
        icons: {
          primary: `${shareItLogoUrl}/logo-share-it-primary.svg`,
          white: `${shareItLogoUrl}/logo-share-it-white.svg`,
          black: `${shareItLogoUrl}/logo-share-it-black.svg`,
        },
      },
    },
    colors: {
      primary: '#00B4CC',
      secondary: '#FFFFFF',
    },
  }, */
};

/* **
Template generating code for various social layouts
** */
/* eslint-disable */
export const generateSocialTemplates = ({ provider }) => {
  const textAndMediaID = crypto.randomUUID();
  const textOnlyID = crypto.randomUUID();
  const mediaOnlyID = crypto.randomUUID();
  return {
    fullScreen: {
      title: 'Social: Single Post',
      contentTypes: allContentTypes,
      contentOptions: {
        textAndMedia: {
          id: textAndMediaID,
          dataElements: [
            {
              key: 'network',
              type: 'image',
              settings: {
                icon: 'far fa-globe',
                noOptionsMenu: true,
                fixedParent: true,
                editable: false,
                backgroundImage: true,
                aspectLock: true,
                noOffCanvasPosition: true,
                backgroundColor: 'transparent',
                data: {
                  type: 'social-network-attribution',
                  required: true,
                  provider,
                  dataKeyMap: {
                    imageUrl: 'logos.svg.icons.white',
                  },
                },
                id: crypto.randomUUID(),
                name: 'Network Icon',
                styles: {
                  height: 40,
                  left: 1786,
                  opacity: 1,
                  top: 221,
                  width: 40,
                  "z-index": 2147483647, // the highest z-index so nothing can go over network icon
                },
              },
            },
            {
              key: 'network',
              type: 'rectangle',
              settings: {
                editable: false,
                data: {
                  provider,
                  dataKeyMap: {
                    backgroundColor: 'colors.primary',
                  },
                },
                id: crypto.randomUUID(),
                name: 'Network Icon Background',
                styles: {
                  height: 80,
                  left: 1766,
                  opacity: 1,
                  top: 201,
                  width: 80,
                },
              },
            },
            {
              key: 'user_profile_image_url',
              type: 'image',
              settings: {
                editable: false,
                fixedParent: true,
                data: {
                  provider,
                  dataKeyMap: {
                    imageUrl: 'user_profile_image_url',
                  },
                },
                id: crypto.randomUUID(),
                mask: true,
                maskShape: 'oval',
                name: 'Avatar',
                styles: {
                  height: 100,
                  left: 996,
                  opacity: 1,
                  top: 201,
                  width: 99,
                },
              },
            },
            {
              key: 'user_real_name',
              type: 'text',
              settings: {
                editable: false,
                fixedParent: true,
                data: {
                  provider,
                  dataKeyMap: {
                    text: 'user_real_name',
                  },
                },
                id: crypto.randomUUID(),
                name: 'Author',
                fitText: true,
                maxSizeText: true,
                styles: {
                  color: 'rgb(51, 51, 51)',
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
                  fontSize: 42,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  height: 53,
                  left: 1116,
                  letterSpacing: 0,
                  maxSizeText: 42,
                  opacity: 1,
                  textAlign: 'left',
                  textBoxOption: 1,
                  textDecoration: 'none',
                  textFlowOption: 1,
                  textTransform: 'none',
                  top: 201,
                  width: 600,
                },
              },
            },
            {
              key: 'user_name',
              type: 'text',
              settings: {
                required: true,
                noOptionsMenu: true,
                editable: false,
                fixedParent: true,
                data: {
                  type: 'social-author-attribution',
                  required: true,
                  noRemap: true,
                  provider,
                  dataKeyMap: {
                    text: 'user_name'
                  },
                },
                id: crypto.randomUUID(),
                name: 'Handle',
                fitText: true,
                maxSizeText: true,
                styles: {
                  color: 'rgb(102, 102, 102)',
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
                  fontSize: 38,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  height: 50,
                  left: 1116,
                  letterSpacing: 0,
                  maxSizeText: 38,
                  opacity: 1,
                  textAlign: 'left',
                  textBoxOption: 1,
                  textDecoration: 'none',
                  textFlowOption: 1,
                  textTransform: 'none',
                  top: 253,
                  width: 600,
                },
              },
            },
            {
              key: 'multi-media',
              type: 'multi-media',
              settings: {
                editable: false,
                fixedParent: true,
                data: {
                  provider,
                  dataKeyMap: {
                    src: 'media',
                    isVideo: 'media',
                    poster: 'media',
                  },
                },
                id: crypto.randomUUID(),
                aspectLock: false,
                fillType: 'fit',
                styles: {
                  height: 854,
                  left: 95,
                  opacity: 1,
                  top: 172,
                  width: 864,
                },
              },
            },
            {
              key: 'html',
              type: 'text',
              settings: {
                editable: false,
                fixedParent: true,
                data: {
                  provider,
                  dataKeyMap: {
                    text: 'html',
                  },
                },
                id: crypto.randomUUID(),
                name: 'Post Content',
                fitText: true,
                maxSizeText: true,
                styles: {
                  color: 'rgb(0, 0, 0)',
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
                  fontSize: 40,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  height: 661,
                  left: 998,
                  letterSpacing: 0,
                  maxSizeText: 40,
                  opacity: 1,
                  textAlign: 'left',
                  textBoxOption: 1,
                  textDecoration: 'none',
                  textFlowOption: 2,
                  textTransform: 'none',
                  top: 335,
                  width: 808,
                },
              },
            },
          ],
          layoutElements: [
          ],
        },
        textOnly: {
          id: textOnlyID,
          dataElements: [
            {
              key: 'network',
              type: 'image',
              settings: {
                icon: 'far fa-globe',
                noOptionsMenu: true,
                fixedParent: true,
                editable: false,
                backgroundImage: true,
                aspectLock: true,
                noOffCanvasPosition: true,
                backgroundColor: 'transparent',
                data: {
                  type: 'social-network-attribution',
                  required: true,
                  provider,
                  dataKeyMap: {
                    imageUrl: 'logos.svg.icons.white',
                  },
                },
                id: crypto.randomUUID(),
                name: 'Network Icon',
                styles: {
                  height: 40,
                  left: 1786,
                  opacity: 1,
                  top: 221,
                  width: 40,
                  "z-index": 2147483647, // the highest z-index so nothing can go over network icon
                },
              },
            },
            {
              key: 'network',
              type: 'rectangle',
              settings: {
                editable: false,
                data: {
                  provider,
                  dataKeyMap: {
                    backgroundColor: 'colors.primary',
                  },
                },
                id: crypto.randomUUID(),
                name: 'Network Icon Background',
                styles: {
                  height: 80,
                  left: 1766,
                  opacity: 1,
                  top: 201,
                  width: 80,
                },
              },
            },
            {
              key: 'user_profile_image_url',
              type: 'image',
              settings: {
                editable: false,
                fixedParent: true,
                data: {
                  provider,
                  dataKeyMap: {
                    imageUrl: 'user_profile_image_url',
                  },
                },
                id: crypto.randomUUID(),
                mask: true,
                maskShape: 'oval',
                name: 'Avatar',
                styles: {
                  height: 100,
                  left: 130,
                  opacity: 1,
                  top: 198,
                  width: 99,
                },
              },
            },
            {
              key: 'user_real_name',
              type: 'text',
              settings: {
                editable: false,
                fixedParent: true,
                data: {
                  provider,
                  dataKeyMap: {
                    text: 'user_real_name',
                  },
                },
                id: crypto.randomUUID(),
                name: 'Author',
                fitText: true,
                maxSizeText: true,
                styles: {
                  color: 'rgb(51, 51, 51)',
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
                  fontSize: 42,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  height: 53,
                  left: 251,
                  letterSpacing: 0,
                  maxSizeText: 42,
                  opacity: 1,
                  textAlign: 'left',
                  textBoxOption: 1,
                  textDecoration: 'none',
                  textFlowOption: 1,
                  textTransform: 'none',
                  top: 200,
                  width: 600,
                },
              },
            },
            {
              key: 'user_name',
              type: 'text',
              settings: {
                required: true,
                noOptionsMenu: true,
                editable: false,
                fixedParent: true,
                data: {
                  type: 'social-author-attribution',
                  required: true,
                  noRemap: true,
                  provider,
                  dataKeyMap: {
                    text: 'user_name'
                  },
                },
                id: crypto.randomUUID(),
                name: 'Handle',
                fitText: true,
                maxSizeText: true,
                styles: {
                  color: 'rgb(102, 102, 102)',
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
                  fontSize: 38,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  height: 50,
                  left: 250,
                  letterSpacing: 0,
                  maxSizeText: 38,
                  opacity: 1,
                  textAlign: 'left',
                  textBoxOption: 1,
                  textDecoration: 'none',
                  textFlowOption: 1,
                  textTransform: 'none',
                  top: 253,
                  width: 600,
                },
              },
            },
            {
              key: 'html',
              type: 'text',
              settings: {
                editable: false,
                fixedParent: true,
                data: {
                  provider,
                  dataKeyMap: {
                    text: 'html',
                  },
                },
                id: crypto.randomUUID(),
                name: 'Post Content',
                fitText: true,
                maxSizeText: true,
                styles: {
                  color: 'rgb(0, 0, 0)',
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
                  fontSize: 40,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  height: 661,
                  left: 131,
                  letterSpacing: 0,
                  maxSizeText: 40,
                  opacity: 1,
                  textAlign: 'left',
                  textBoxOption: 1,
                  textDecoration: 'none',
                  textFlowOption: 2,
                  textTransform: 'none',
                  top: 327,
                  width: 1667,
                },
              },
            },
          ],
          layoutElements: [
          ],
        },
        mediaOnly: {
          id: mediaOnlyID,
          dataElements: [
            {
              key: 'network',
              type: 'image',
              settings: {
                icon: 'far fa-globe',
                noOptionsMenu: true,
                fixedParent: true,
                editable: false,
                backgroundImage: true,
                aspectLock: true,
                noOffCanvasPosition: true,
                backgroundColor: 'transparent',
                data: {
                  type: 'social-network-attribution',
                  required: true,
                  provider,
                  dataKeyMap: {
                    imageUrl: 'logos.svg.icons.white',
                  },
                },
                id: crypto.randomUUID(),
                name: 'Network Icon',
                styles: {
                  height: 40,
                  left: 1786,
                  opacity: 1,
                  top: 221,
                  width: 40,
                  "z-index": 2147483647, // the highest z-index so nothing can go over network icon
                },
              },
            },
            {
              key: 'network',
              type: 'rectangle',
              settings: {
                editable: false,
                data: {
                  provider,
                  dataKeyMap: {
                    backgroundColor: 'colors.primary',
                  },
                },
                id: crypto.randomUUID(),
                name: 'Network Icon Background',
                styles: {
                  height: 80,
                  left: 1766,
                  opacity: 1,
                  top: 201,
                  width: 80,
                },
              },
            },
            {
              key: 'user_profile_image_url',
              type: 'image',
              settings: {
                editable: false,
                fixedParent: true,
                data: {
                  provider,
                  dataKeyMap: {
                    imageUrl: 'user_profile_image_url',
                  },
                },
                id: crypto.randomUUID(),
                mask: true,
                maskShape: 'oval',
                name: 'Avatar',
                styles: {
                  height: 100,
                  left: 186,
                  opacity: 1,
                  top: 864,
                  width: 99,
                },
              },
            },
            {
              key: 'user_real_name',
              type: 'text',
              settings: {
                editable: false,
                fixedParent: true,
                data: {
                  provider,
                  dataKeyMap: {
                    text: 'user_real_name',
                  },
                },
                id: crypto.randomUUID(),
                name: 'Author',
                fitText: true,
                maxSizeText: true,
                styles: {
                  color: 'rgb(255,255,255)',
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
                  fontSize: 42,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  height: 53,
                  left: 308,
                  letterSpacing: 0,
                  maxSizeText: 42,
                  opacity: 1,
                  textAlign: 'left',
                  textBoxOption: 1,
                  textDecoration: 'none',
                  textFlowOption: 1,
                  textTransform: 'none',
                  top: 864,
                  width: 600,
                },
              },
            },
            {
              key: 'user_name',
              type: 'text',
              settings: {
                required: true,
                noOptionsMenu: true,
                editable: false,
                fixedParent: true,
                data: {
                  type: 'social-author-attribution',
                  required: true,
                  noRemap: true,
                  provider,
                  dataKeyMap: {
                    text: 'user_name'
                  },
                },
                id: crypto.randomUUID(),
                name: 'Handle',
                fitText: true,
                maxSizeText: true,
                styles: {
                  color: 'rgb(255,255,255)',
                  fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
                  fontSize: 38,
                  fontStyle: 'normal',
                  fontWeight: 'normal',
                  height: 50,
                  left: 308,
                  letterSpacing: 0,
                  maxSizeText: 38,
                  opacity: 1,
                  textAlign: 'left',
                  textBoxOption: 1,
                  textDecoration: 'none',
                  textFlowOption: 1,
                  textTransform: 'none',
                  top: 916,
                  width: 600,
                },
              },
            },
            {
              key: 'multi-media',
              type: 'multi-media',
              settings: {
                editable: false,
                fixedParent: true,
                data: {
                  provider,
                  dataKeyMap: {
                    src: 'media',
                    isVideo: 'media',
                    poster: 'media',
                  },
                },
                id: crypto.randomUUID(),
                aspectLock: false,
                fillType: 'fit',
                styles: {
                  left: 95,
                  opacity: 1,
                  top: 172,
                  width: 1725,
                  height: 854,
                },
              },
            },
          ],
          layoutElements: [
          ],
        },
      },
    },
  };
};
